import * as yup from 'yup';


export const validationSchema = yup.object({
    categoryName: yup
        .string()
        .required('Required'),
    description: yup
        .string()
        .required('Required'), 
}).required();

export const initialValues = {
    categoryName: "",
    description: "",
    status: true,
}
